import styled from "styled-components";

export const InnerContainer = styled.div`
    max-width: 1520px;
    width: 100%;
    margin: 0 auto;
    padding: 0 20px;

    a {
        cursor: pointer;
    }
`;
